import { render, staticRenderFns } from "./TaskSearch.vue?vue&type=template&id=48b53244&scoped=true&"
import script from "./TaskSearch.vue?vue&type=script&lang=js&"
export * from "./TaskSearch.vue?vue&type=script&lang=js&"
import style0 from "./TaskSearch.vue?vue&type=style&index=0&id=48b53244&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b53244",
  null
  
)

export default component.exports